module.exports = __webpack_public_path__ + "static/media/gallery-6.5578b874.JPG";